const map = new Map<string, File>();

export const composerFileStore = {
  set(id: string, file: File) {
    map.set(id, file);
  },
  get(id: string) {
    return map.get(id);
  },
  remove(id: string) {
    map.delete(id);
  },
  getMany(ids: string[]): File[] {
    return ids.map((id) => map.get(id)).filter((file): file is File => file instanceof File);
  },
  clearMany(ids: string[]) {
    ids.forEach((id) => map.delete(id));
  },
};
